import { getFilterIds } from "@tIntermatic/Services/NewsFilterService";
import { NewsListFilterState } from "@tIntermatic/Store/Components/NewsListFilter/NewsListFilterState";

export const getNewsFilters = () => {
    const newsListFilter: NewsListFilterState = {
        marketFilters: getFilterIds("market"),
        solutionFilters: getFilterIds("solution"),
        typeFilters: getFilterIds("type"),
    };
    return newsListFilter;
};
